// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._5rxL7b {\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n  color: #ccc;\n  -webkit-transition: 2s linear background;\n  transition: 2s linear background;\n}\n\n.OPBdlY {\n  position: absolute;\n  white-space: pre;\n  font-family: monospace;\n  cursor: default;\n}\n\n.OPBdlY a {\n  position: relative;\n  color: black;\n  background: white;\n  opacity: 0.8;\n  cursor: pointer;\n  z-index: 10;\n  font-size: 13px;\n  border: 2px solid white;\n  padding: 3px 5px;\n}\n\n.OPBdlY a:hover {\n    opacity: 1;\n  }\n", ""]);
// Exports
exports.locals = {
	"textWrapper": "_5rxL7b",
	"face": "OPBdlY"
};